export enum MaritalStatusEnum {
  NoResponse = 0,
  Married = 1,
  Divorced = 2,
  Widowed = 3,
  Single = 4,
  Seperate = 5,
  Unknown = 6
}

export const MaritalStatusOptions = [
{ id: 0, label: 'No Response' },
{ id: 1, label: 'Married' },
{ id: 2, label: 'Divorced' },
{ id: 3, label: 'Widowed' },
{ id: 4, label: 'Single' },
{ id: 5, label: 'Seperate' },
{ id: 6, label: 'Unknown' }
];
